<template>
    <div class="garyaBg">
        <!-- section one -->
        <section ref="animationSection" class="flex flexmobile mx-auto flex-row md:gap-10  md:mt-12  md:px-20 justify-between">
            <div>
                <p class="text-rose-300 flexmobile text-3xl dancing-script pt-10 pb-10">Before:</p>
                <img loading="lazy" ref="beforeImage" :class="beforeImageClass" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662391/before_jzchhc.png" alt="">
            </div>
            <div>
                <p class="text-rose-300 flexmobile text-3xl dancing-script pt-10 pb-10">After:</p>
                <img loading="lazy" ref="afterImage" :class="afterImageClass" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662404/after_jyokch.png" alt="">
            </div>
        </section>
    <!-- section 2 -->
    <section class="flex flex-col flexmobile md:flex-row md:mt-44 justify-between  mx-auto md:px-20">
            <div class="text-white mt-4">
                <p class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-6">Social Media Marketing</p>
                <ul class="pt-6 text-lg ">
                  <li class="pt-6 text-lg ">Social media accounts like Facebook, Instagram and Youtube were leveraged for the following:</li>
                    <li class="pt-6 text-lg ">Increase awareness and reach</li>
                    <li class="pt-6 text-lg ">Boost engagement for Volunteer Recruitment</li>
                    <li class="pt-6 text-lg ">Impactful Visual Storytelling</li>
                    <li class="pt-6 text-lg ">Donations and Fundraising</li>
                    <li class="pt-6 text-lg ">Connect directly with audience to build community & long-term relationships</li>
                </ul>
            </div>
            <div>
                <img loading="lazy" class="mobile-img" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662482/hp_vfw9t5.png" alt="">
            </div>
        </section>
     <!-- section 3 -->
     <section class="container mt-4 mx-auto px-20 flexmobile">
     <div class="flex justify-between ">
    <a href="https://www.youtube.com/watch?v=hyKW0a8Yv5g&t=4s"><img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662516/youtube_1_yrrp4n.png" alt="" class="w-24 mobileWidth"></a>
     <a href="https://www.instagram.com/warriorwagonsinc/"><img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662529/Instagram-Logo_1_ieizss.png" alt="" class="w-[9rem] mobileWidth mt-2"></a>
     <a href="https://www.facebook.com/WarriorWagonsINC/"><img src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662543/Facebook-logo_1_1_jya86b.png" alt="" class="w-[9rem] mobileWidth"></a>
     </div>
     </section>
     <!-- section 4 -->
     <section class=" w-full mt-32 flexmobile px-10">
        <div>
            <img loading="lazy" class="w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662628/Group_1947_1_bk4wdj.png" alt="">
        </div>
    </section>
    <!-- section 5  -->
    <section class="mx-auto  mt-32 text-lg flexmobile  px-20 ">
      <h2 class="dancing-script text-white text-2xl md:text-3xl font-semibold pt-6">Video Story</h2>
        <div class="text-white pt-6 text-lg md:pt-16  ">
            <p>Delivered a <span class="text-rose-300"> short introductory video </span> of Warrior Wagons to help understand the <span class="text-rose-300"> vision and mission </span> of the Non-profit to foster partnerships and collaborations.</p>
        </div>
        <div class="flex justify-center">
            <iframe
        class="mt-10 center w-[80%]"
        width=""
        height="800"
        src="https://www.youtube.com/embed/hyKW0a8Yv5g?start=4"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        ></iframe>
        </div>
    </section>
    <!-- section 6 -->
    <section class="text-white flexmobile md:mt-32  mx-auto md:px-20">
        <div>
            <p class="text-rose-300 text-2xl md:text-3xl font-semibold pt-6">Enhanced the visual look and feel of the website</p>
            <p class="text-whire text-2xl md:text-3xl pt-6">Style Guide Changes</p>
        </div>
        <div class=" flex   md:w-full md:ml-5 md:px-44 justify-center flex-col justify-self-center">
          <div class="flex mt-6 gap-4 md:mb-10 md:w-[700px]  text-3xl md:ml-5 dancing-script text-white justify-around md:justify-between ">
          <div class=" text-rose-300 mt-8">Before :</div>
          <div class=" text-rose-300 mt-8">After  :</div>
        </div>
        <div class="flex  justify-between flex-col justify-self-center ">
        <img loading="lazy" class="colorsImageMobile" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662690/Group_1966_ycnixl.png" alt="">
        <div class="flex gap-10 md:text-4xl md:mt-10 dancing-script items-center  text-white  md:gap-64 justify-between">
        <p class="text-center text-3xl" >Used to be jumpy and too bold</p>
        <p class="text-center text-3xl mr-12">Shows strength and courage</p>
        </div>
        </div>
        <div class="flex pt-4  justify-between md:mt-20 flex-col justify-self-center ">
        <img loading="lazy" class="colorsImageMobile" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662702/Group_1967_ywh7m6.png" alt="">
        <div class="flex pt-4 text-lg gap-10 md:text-4xl md:mt-10 dancing-script items-center  text-white  md:gap-72 justify-between">
        <p class="text-center text-3xl">Used to be somber</p>
        <p class="text-center text-3xl mr-12">Shows positivity and hope</p>
        </div>
        </div>
        <div class="flex pt-4 justify-between md:mt-20 flex-col justify-self-center ">
        <img loading="lazy" class="colorsImageMobile" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662797/Group_1968_obljq7.png" alt="">
        <div class="flex pt-4 text-lg gap-4 md:text-4xl md:mt-10 dancing-script items-center  text-white  md:gap-64 justify-between">
        <p class="text-center text-3xl">Used to be high contrast</p>
        <p class="text-center text-3xl mr-24">Gives a balanced look</p>
        </div>
        </div>
        </div>
      
    </section>
    <!-- section 7 -->
    <section class="text-white md:mt-32 mt-10 px-10  mx-auto md:px-20">
  <div class="flex flex-col md:flex-row items-center md:gap-14 justify-between">
    <!-- Style Guide Title with Gradient -->
    <p class="new-gradient text-2xl md:text-5xl font-bold -mt-80 md:mb-0">NEW STYLE GUIDE</p>

    <!-- Colors and Typography Image -->
    <img loading="lazy" class="md:w-1/2 w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726662943/Group_1970_ktau8j.png" alt="Style Guide">
  </div>
</section>

<!-- Section 8: Color and Typography Details -->
<section class="section-image mt-32 bg-black py-20">
  <section class="text-white mx-auto ">
    <div class="mx-auto md:px-20 px-5">
      <!-- Color Palette and Typography Details Image -->
      <img loading="lazy" class="w-full" src="https://res.cloudinary.com/dkdzcp4au/image/upload/v1726663011/Group_34185_2_qgdlyu.png" alt="Color and Typography">
    </div>
  </section>
</section>

    </div>
</template>

<script>
export default{
name:'WangosProjectThree',
data() {
      return {
        beforeImageClass: 'opacity-0', // Initially hidden
        afterImageClass: 'opacity-0' // Initially hidden
      };
    },
    mounted() {
      const observerOptions = {
        root: null, // Uses the viewport as the root
        threshold: 0.1 // 10% of the element should be visible
      };
  
      const observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            // Trigger animations when the section is in view
            this.beforeImageClass = 'animate__animated animate__zoomInLeft opacity-100';
            this.afterImageClass = 'animate__animated animate__zoomInRight opacity-100';
  
            // Ensure the animations only happen once by unobserving
            observer.unobserve(entry.target);
          }
        });
      }, observerOptions);
  
      // Observe the section with the images
      observer.observe(this.$refs.animationSection);
    }
}
</script>

<style>
@media (max-width:640px) {
    .mobileWidth{
        width: 50px;
        height: 50px;
    }
    .image-container{
    max-width: 400px !important;
    }
    .colorsImageMobile{
  max-width: 300px;
}
}
.new-gradient{
  background: linear-gradient(90deg, #C0150D 0%, #FFD643 100%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
font-family: Montserrat;
font-style: normal;
font-weight: 700;
line-height: 100%; /* 50px */
}
.section-image{
  background-image: url("https://res.cloudinary.com/dkdzcp4au/image/upload/v1726879514/Group_34221_1_ss1b7j.png");
  background-size: contain;
}

</style>
